import "./App.css";
import "./scss/_overview.scss";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./component/Dashboard";
import DefaultLayout from "./component/DefaultLayout";
import GuestLayout from "./component/GuestLayout";
import Login from "./component/Login";
import NotAuthorized from "./component/NotAuthorized";
import NotFound from "./component/NotFound";
import Signup from "./component/Signup";
import AdminDashboard from "./component/admin/AdminDashboard";
import AdminLayout from "./component/admin/AdminLayout";
import NewUser from "./component/admin/users/newuser";
import AdminProfile from "./component/admin/profile/AdminProfile";
import Users from "./component/admin/users/Users";
import AdminMail from "./component/admin/users/AdminMail";
import Reviews from "./component/admin/product/Reviews";
import UserDashboard from "./component/user/UserDashboard";
import UserLayout from "./component/user/UserLayout";
import UserProfile from "./component/user/profile/UserProfile";

import Orders from "./component/user/order/orders";
import Products from "./component/user/product/products";

import { default as AdminProducts } from "./component/admin/product/products";
import ProductTypes from "./component/admin/producttype/producttypes";
import NewProduct from "./component/admin/product/newproduct";
import NewProductType from "./component/admin/producttype/newproducttype";
import Error from "./component/error";
import Logs from "./component/admin/log/logs";
import Files from "./component/admin/files/files";
import Favorites from "./component/user/favorite/favorites";
import { ShoppingCart } from "./component/user/shopping-cart/ShoppingCart";
import RefundRequests from "./component/admin/refund/RefundRequests";
import { Instagram, Pdc, UploadManagement } from "./component/admin/Tools";
import TwoFactor from "./component/TwoFactor";
import SuperUserLayout from "./component/admin/SuperUserLayout";
import FaqManager from "./component/admin/faq/FaqManager";
import Invoices from "./component/admin/invoice/Invoices";
import Timesheets from "./component/admin/timesheet/Timesheets";
import ChatManager from "./component/admin/chat/ChatManager";

function App() {
  


  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<DefaultLayout />}>
          <Route
            index
            element={ <Dashboard /> }
          />

          <Route path="/admin" element={<AdminLayout />}>
            <Route
              index
              element={ <AdminDashboard /> }
            />
            <Route
              path="/admin/users"
              element={ <Users /> }
            />
            <Route
              path="/admin/users/:id"
              element={ <Users /> }
            />
            <Route path="/admin/mail" element={<AdminMail />} />
            <Route path="/admin/reviews" element={<Reviews />} />
            <Route
              path="/admin/profile"
              element={ <AdminProfile /> }
            />
            <Route
              path="/admin/user"
              element={ <NewUser /> }
            />
            <Route
              path="/admin/products"
              element={<AdminProducts />}
            />
            <Route
              path="/admin/products/:id"
              element={ <AdminProducts /> }
            />
            <Route
              path="/admin/producttypes"
              element={ <ProductTypes /> }
            />
            <Route
              path="/admin/producttypes/:id"
              element={ <ProductTypes /> }
            />
            <Route
              path="/admin/product"
              element={ <NewProduct /> }
            />
            <Route
              path="/admin/producttype"
              element={ <NewProductType /> }
            />
            <Route
              path="/admin/logs"
              element={ <Logs /> }
            />
            <Route
              path="/admin/files"
              element={ <Files /> }
            />
            <Route path="/admin/refund-requests" element={<RefundRequests />} />
            <Route path="/admin/pdc" element={<SuperUserLayout><Pdc /></SuperUserLayout>} />
            <Route path="/admin/invoices" element={<SuperUserLayout><Invoices /></SuperUserLayout>} />
            <Route path="/admin/invoices/new" element={<SuperUserLayout><Invoices /></SuperUserLayout>} />
            <Route path="/admin/invoices/:id/edit" element={<SuperUserLayout><Invoices /></SuperUserLayout>} />
            <Route path="/admin/invoices/:id" element={<SuperUserLayout><Invoices /></SuperUserLayout>} />
            <Route path="/admin/timesheets" element={<SuperUserLayout><Timesheets /></SuperUserLayout>} />
            <Route path="/admin/timesheets/new" element={<SuperUserLayout><Timesheets /></SuperUserLayout>} />
            <Route path="/admin/timesheets/:id/edit" element={<SuperUserLayout><Timesheets /></SuperUserLayout>} />
            <Route path="/admin/timesheets/:id" element={<SuperUserLayout><Timesheets /></SuperUserLayout>} />
            <Route path="/admin/instagram" element={<Instagram />} />
            <Route path="/admin/uploadmanagement" element={<UploadManagement />} />
            <Route path="/admin/faqs" element={<FaqManager />} />
            <Route path="/admin/chat" element={<ChatManager />} />
            <Route path="/admin/error/:message" element={<Error />} />
          </Route>

          <Route path="/" element={<UserLayout />}>
            <Route
              index
              element={ <UserDashboard /> }
            />
            <Route
              path="/profile"
              element={ <UserProfile /> }
            />
            <Route
              path="/orders"
              element={<Orders /> }
            />
            <Route
              path="/products"
              element={ <Products /> }
            />
            <Route
              path="/products/:id"
              element={ <Products /> }
            />
            <Route
              path="/favorites"
              element={<Favorites /> }
            />
            <Route
              path="/cart"
              element={
                 
                 
                    <ShoppingCart />
                  
                
              }
            />
          </Route>
        </Route>

        <Route path="/" element={<GuestLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/2fa/setup" element={<TwoFactor />} />
          <Route path="/2fa/challenge" element={<TwoFactor />} />
          <Route path="/signup" element={<Signup />} />
        </Route>

        <Route path="*" element={<NotFound />} />
        <Route path="/401" element={<NotAuthorized />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
